<div class="toolbar-container">
    @if (organisation && linqset) {
        <app-toolbar-buttons [organisation]="organisation" [dropdown]="false" [screen]="screen" [linqset]="linqset" [modelType]="modelType" [selectedTagGroup]="selectedTagGroup" [graphComponent]="graphComponent" [readonlyGraph]="readOnly" [functions]="functions" [highlights]="highlights" [canCompare]="canCompare" [comparing]="comparing" (toolbarEvent)="handleToolbarEvent($event)"></app-toolbar-buttons>
        @if (!readOnly && (app.mediumScreen || app.largeScreen)) {
            <button mat-icon-button [matMenuTriggerFor]="graphMenu" matTooltip="More model functions" aria-label="More model functions">
                <mat-icon>menu</mat-icon>
            </button>

            <mat-menu #graphMenu="matMenu">
                <app-toolbar-buttons [organisation]="organisation" [dropdown]="true" [screen]="screen" [linqset]="linqset" [modelType]="modelType" [selectedTagGroup]="selectedTagGroup" [graphComponent]="graphComponent" [readonlyGraph]="readOnly" [functions]="functions" [highlights]="highlights" [canCompare]="canCompare" [comparing]="comparing" (toolbarEvent)="handleToolbarEvent($event)"></app-toolbar-buttons>
            </mat-menu>
        }
    }
</div>
